var map = {
	"./bannerplaceholder.png": 2090,
	"./healthwise-icon.png": 335,
	"./logo.png": 486,
	"./mgl-icon-email.png": 5926,
	"./mgl-icon-fax.png": 571,
	"./mgl-icon-location.png": 961,
	"./mgl-icon-phone.png": 3438,
	"./powered_by_google_on_white.png": 227,
	"./powered_by_google_on_white_hdpi.png": 3457,
	"./saskatoon.png": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5044;